<template>
  <div class="share-links-farming" v-bind:class="{ showShare: isActive }">
    <span class="share-links-farming__text">Share to:</span>
    <div class="share-links-farming__wrapper">
      <BaseButton class="share-links-farming__button" variant="twitter" rounded="full">
        <twitter-logo/>
      </BaseButton>
      <BaseButton class="share-links-farming__button" variant="facebook" rounded="full">
        <facebook-logo/>
      </BaseButton>
      <BaseButton class="share-links-farming__button" variant="linkedin" rounded="full">
        <linkedin-logo/>
      </BaseButton>
      <BaseButton class="share-links-farming__button" variant="google" rounded="full">
        <google-logo/>
      </BaseButton>
      <BaseButton class="flex-shrink-0" variant="email" rounded="full">
        <BaseIcon name="email" size="20"></BaseIcon>
      </BaseButton>
    </div>
    <div class="share-links-farming__copy">
      <BaseButton class="flex-shrink-0" variant="white" rounded="full">
        <BaseIcon name="link" size="20"></BaseIcon>
      </BaseButton>
      <input
        class="share-links-farming__input"
        type="text"
        value="http://morrisons.com/plastic.html"
      >
      <BaseButton
        class="share-links-farming__close"
        variant="primary"
        rounded="full"
        @click="$emit('toggled')"
        v-bind:class="{ showShare: isActive }"
      >
        <BaseIcon name="close" size="20"></BaseIcon>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TwitterLogo from '@/assets/svg/logo-twitter.svg?inline'
import FacebookLogo from '@/assets/svg/logo-facebook.svg?inline'
import LinkedinLogo from '@/assets/svg/logo-linkedin.svg?inline'
import GoogleLogo from '@/assets/svg/logo-googleplus.svg?inline'

export default {
  name: 'ShareLinksFarming',
  components: {
    TwitterLogo,
    FacebookLogo,
    LinkedinLogo,
    GoogleLogo,
    BaseButton,
    BaseIcon
  },
  props: ['isActive']
}
</script>

<style lang="postcss">
.share-links-farming {
  @apply hidden absolute w-full left-0 px-6;
  background-color: transparant;
}
.showShare {
  @apply block bottom-0;
}
.share-links-farming__text {
  @apply block my-2 text-lg text-white;
}
.share-links-farming__wrapper {
  @apply flex flex-wrap mb-6;
}
.share-links-farming__button {
  @apply fill-current mb-2 mr-2 flex-shrink-0;
}
.share-links-farming__button svg {
  @apply h-4;
}
.share-links-farming__email {
  @apply flex-shrink-0;
}
.share-links-farming__copy {
  @apply flex justify-between items-center mb-5;
}
.share-links-farming__close {
  @apply flex-shrink-0;
}
.share-links-farming__input {
  @apply text-base bg-white border border-body-lighter p-4 mx-4 w-11/12;
}
</style>